import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=41d8c71d&scoped=true&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=41d8c71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d8c71d",
  null
  
)

/* custom blocks */
import block0 from "./NewUser.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports